var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#efefef",
    width: "800px",
    height: "800px",
    viewBox: "-7.5 0 32 28",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#efefef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "nine"), /*#__PURE__*/React.createElement("path", {
    d: "M3.844 25.219l5.813-9.125c-0.406 0.063-0.844 0.125-1.281 0.125-3.938 0-7.094-3.188-7.094-7.094 0-3.938 3.156-7.125 7.094-7.125 3.281 0 6.063 2.281 6.875 5.344 0.125 0.531 0.25 1.188 0.25 1.781 0 1.344-0.406 2.563-1.031 3.625l-0.219 0.344-8.531 13.344zM12.156 12.188l0.594-0.906c0.344-0.688 0.5-1.375 0.5-2.156 0-2.688-2.188-4.906-4.875-4.906s-4.875 2.219-4.875 4.906 2.188 4.844 4.875 4.844c1.531 0 2.875-0.688 3.781-1.781z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNine);
export default __webpack_public_path__ + "static/media/nine.77588baaaf1efc7a9d69895ad78da8cd.svg";
export { ForwardRef as ReactComponent };